import { jsx as p } from "react/jsx-runtime";
import { ListItem as h, OrderedList as M, BulletList as z } from "../../node_modules/@tiptap/extension-list/dist/index.mjs";
import { ReactNodeViewRenderer as u, NodeViewWrapper as I, NodeViewContent as C } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { convertStyleObjectToCss as c } from "../../utils/style-helpers.mjs";
import { Plugin as F, PluginKey as k } from "../../node_modules/prosemirror-state/dist/index.mjs";
import { LIST_STYLES as L } from "../../constants/default-styles.mjs";
import { CustomBulletList as A } from "./custom-bullet-list.mjs";
import { CustomOrderedList as H } from "./custom-ordered-list.mjs";
import { getOrderedListStyleType as N, getBulletListStyleType as O } from "./utils/list.mjs";
import { getListIcon as Z, setList as $ } from "./utils/list.mjs";
import { mergeAttributes as m } from "../../node_modules/@tiptap/core/dist/index.mjs";
const V = new k("listItemStyle"), b = ({ node: t }) => {
  const e = {};
  return t.attrs.fontSize && (e.fontSize = t.attrs.fontSize), t.attrs.fontFamily && (e.fontFamily = t.attrs.fontFamily), t.attrs.color && (e.color = t.attrs.color), t.attrs.textAlign && (e.textAlign = t.attrs.textAlign), /* @__PURE__ */ p(I, { as: "li", style: e, children: /* @__PURE__ */ p(C, {}) });
}, D = h.extend({
  content: "block*",
  addAttributes() {
    var t;
    return {
      ...(t = this.parent) == null ? void 0 : t.call(this),
      fontSize: {
        default: null,
        parseHTML: () => null,
        renderHTML: () => ({})
      },
      fontFamily: {
        default: null,
        parseHTML: () => null,
        renderHTML: () => ({})
      },
      color: {
        default: null,
        parseHTML: () => null,
        renderHTML: () => ({})
      }
    };
  },
  addNodeView() {
    return u(b);
  },
  addProseMirrorPlugins() {
    return [
      new F({
        key: V,
        appendTransaction: (t, e, i) => {
          if (!t.some((r) => r.docChanged))
            return null;
          const y = i.tr;
          let S = !1;
          const a = (r) => r == null ? void 0 : r.find((l) => l.type.name === "textStyle"), x = (r) => {
            const l = r.firstChild;
            if (!l)
              return null;
            if (l.isText)
              return a(l.marks);
            const n = l.firstChild;
            return n != null && n.isText ? a(n.marks) : null;
          };
          return i.doc.descendants((r, l) => {
            if (r.type.name === "listItem") {
              let n = null, f = null, d = null;
              const T = x(r), s = i.selection, g = s.anchor >= l && s.anchor < l + r.nodeSize || s.head >= l && s.head < l + r.nodeSize ? a(i.storedMarks) : null, o = T || g;
              o && (n = o.attrs.fontSize, f = o.attrs.fontFamily, d = o.attrs.color), (r.attrs.fontSize !== n || r.attrs.fontFamily !== f || r.attrs.color !== d) && (y.setNodeMarkup(l, void 0, {
                ...r.attrs,
                fontSize: n,
                fontFamily: f,
                color: d
              }), S = !0);
            }
          }), S ? y : null;
        }
      })
    ];
  },
  renderHTML({ HTMLAttributes: t, node: e }) {
    const i = {};
    return e.attrs.fontSize && (i.fontSize = e.attrs.fontSize), e.attrs.fontFamily && (i.fontFamily = e.attrs.fontFamily), e.attrs.color && (i.color = e.attrs.color), e.attrs.textAlign && (i.textAlign = e.attrs.textAlign), [
      "li",
      m(t, {
        ...Object.keys(i).length > 0 ? { style: c(i) } : {}
      }),
      0
    ];
  }
}), J = z.extend({
  addAttributes() {
    return {
      depth: {
        default: 0
      }
    };
  },
  addNodeView() {
    return u(A);
  },
  renderHTML({ HTMLAttributes: t }) {
    const { depth: e } = t;
    return [
      "ul",
      m(t, {
        style: c({
          ...L,
          listStyleType: O(e)
        })
      }),
      0
    ];
  }
}), Q = M.extend({
  addAttributes() {
    return {
      depth: {
        default: 0
      }
    };
  },
  addNodeView() {
    return u(H);
  },
  renderHTML({ HTMLAttributes: t }) {
    const { depth: e } = t;
    return [
      "ol",
      m(t, {
        style: c({
          ...L,
          listStyleType: N(e)
        })
      }),
      0
    ];
  }
});
export {
  J as BulletListExtension,
  A as CustomBulletList,
  H as CustomOrderedList,
  D as ListItemExtension,
  Q as OrderedListExtension,
  O as getBulletListStyleType,
  Z as getListIcon,
  N as getOrderedListStyleType,
  $ as setList
};
